export async function addChildNode(addChildNodeInput: any, jwtToken: string) {

    const body = JSON.stringify({
        operationName: null,
        query: `
			mutation($input: AddChildNodeInput!) {
				addChildNode(input: $input) {
					nodeID revisionID linkID doneAt
				}
			}
		`,
        variables: {
            input: addChildNodeInput
        },
    })

    const response_stream = await fetch(`https://app-server.debatemap.app/graphql`, {
        method: "POST",
        body: body,
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${jwtToken}`,
        },
    });
    const responseAsString = await response_stream.text();
    const responseAsObject = JSON.parse(responseAsString);
    console.log(responseAsObject);

    return responseAsObject;
}
